import React, { Suspense, useRef, } from 'react'
import { Scrollbars } from 'react-custom-scrollbars-2';
import './Chat.scss'
import { ErrorBoundary } from '../../Common/ErrorBoundry';
import { MenuProps } from '../Contacts/ContactsMenu';
import { HeaderOptions } from '../HeaderOptions';

//@ts-expect-error
const ChatList = React.lazy(() => import("chat/ChatList"));

//const ChatCount = React.lazy(() => import("chat/ChatCount"));

//const PinnedChatModule = React.lazy(() => import("chat/PinnedChats"));
//@ts-expect-error
const ChatMenuModule = React.lazy(() => import("chat/ChatVisibilityMenu"));


export const ChatBar = (props) => {
    const ChatHeaderOptions = [
        {
            id: "settings",
            title: `Settings`,
            element: <button className='icon settings k-font-icon k-i-gear' title='Settings'></button>,
            onclick: () => { },
            visible: true
        },
        {
            id: "win",
            title: `Fullscreen`,
            element: <button className='icon settings k-font-icon k-i-hyperlink-open' title='Open in New Window'></button>,
            link: '/Chat',
            visible: true
        }] as HeaderOptions[]

    return (
        <section className='chat' onMouseLeave={props.onMouseLeave} >
            <ErrorBoundary errorMessage={<div className='m-5'><span className='k-font-icon k-i-close-circle' />Error: Failed to connect to chat service.</div>}>
                <Scrollbars autoHeight={false}>
                    <Suspense fallback={'Loading...'}>
                        <header className='right-bar-header' >
                            <img alt='chat' className='icon' src='./images/Chat.png' width='25' height='25' style={{ alignContent: 'center' }} />
                            <span className='text'>Chat</span>
                            {/* <button ref={headerRef} className='icon k-font-icon k-i-more-horizontal' title='More options' onClick={(e) => {
                                setHeaderMenu((m) => { return { ...m, visible: !m?.visible, offset: { top: headerRef.current.offsetTop + 40, left: headerRef.current.offsetLeft - 150 } } })
                            }} /> */}
                            <ChatMenuModule />
                            {!props.fullScreen && <button className='icon lock' onClick={props.unlocked} title='Unlock side-bar' ><img alt='lock contacts bar' src='./images/contacts-lock.png' style={{ alignContent: 'center' }} /></button>}
                            {!props.fullScreen && <button className='icon unlock' onClick={props.locked} title='Lock side-bar' ><img alt='unlock contacts bar' src='./images/contacts-unlock.png' style={{ alignContent: 'center' }} /></button>}
                        </header>
                        {/* <HeaderMenu {...headerMenu} options={ChatHeaderOptions.filter(o => o.visible)} itemClicked={() => setHeaderMenu(null)} /> */}


                        <ChatList showHeader={false} pinChatOnClick={true} />
                    </Suspense>
                </Scrollbars>
            </ErrorBoundary>
        </section >
    )
}
